<template>
    <div class="email-step">
        <form @submit.prevent="nextStep" class="email-form">
            <label for="email" class="email-label">Email*</label>
            <input
                v-model="$v.userData.email.$model"
                @keydown="$v.userData.email.$touch"
                @keyup.enter="nextStep"
                id="email"
                type="text"
                class="email-input"
                placeholder="Enter your email to get started..."
            />
            <span
                v-if="$v.userData.email.$dirty && !$v.userData.email.required"
                class="error-form-message"
            >
                Email field is required.
            </span>
            <span
                v-if="$v.userData.email.$dirty && !$v.userData.email.email"
                class="error-form-message"
            >
                Please enter a valid email.
            </span>
        </form>
        <div class="actions">
            <button @click="nextStep" :disabled="$v.$invalid" class="cta-btn" type="button">
                Continue
            </button>
        </div>
    </div>
</template>
<script>
    import { useArtistClaimProfile } from '@/composables/features/artist-claim-profile/useArtistClaimProfile'
    import { required, email } from 'vuelidate/lib/validators'
    export default {
        name: 'EmailStep',
        setup() {
            const { userData, updateStep } = useArtistClaimProfile()
            return {
                userData,
                updateStep
            }
        },
        validations: {
            userData: {
                email: { required, email }
            }
        },
        methods: {
            nextStep() {
                if (this.userData.email && this.formValid()) {
                    this.updateStep('info-step')
                }
            },
            formValid() {
                this.$v.$touch()
                return !this.$v.$invalid
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    $mobileMax: 600px;

    @media screen and (max-width: $mobileMax) {
        .email-form {
            padding-left: 0px !important;
            padding-right: 0px !important;
            padding-bottom: 40px !important;
            border-bottom: none !important;
        }
        .actions {
            padding-left: 0px !important;
            padding-right: 0px !important;

            .cta-btn {
                width: 100%;
            }
        }
    }
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }
    .email-step {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: center;
        justify-content: center;
        width: 100%;

        .email-form {
            padding-bottom: 176px;
            border-bottom: 1px solid #333333;
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 6px;
            align-items: flex-start;
            justify-content: center;
            padding-left: 56px;
            padding-right: 56px;

            .email-label {
                color: #8b8b8b;
                @include base-font-12;
                font-weight: 650;
                line-height: 135%;
                letter-spacing: 0.12px;
            }
            .email-input {
                width: 100%;
                padding: 12px 16px 16px 16px;
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                background: #262626;
                color: #dedede;
                @include base-font-16;
                font-weight: 550;
                line-height: 125%;
            }
            .email-input::placeholder {
                overflow: hidden;
                color: #646464;
                text-overflow: ellipsis;
                white-space: nowrap;
                @include base-font-16;
                font-weight: 550;
                line-height: 125%;
            }
            .email-input:focus {
                border: 1px solid #cdeb09;
            }
            .email-input:active {
                border: 1px solid #cdeb09;
            }
            .error-form-message {
                color: #ed3c0d;
                @include base-font-10;
                font-weight: 600;
                line-height: 130%;
                letter-spacing: 0.14px;
            }
        }
        .actions {
            width: 100%;
            padding: 16px 24px;

            .cta-btn {
                margin-left: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 12px 32px;
                border-radius: 120px;
                background: #cdeb09;
                color: #000;
                @include base-font-18;
                line-height: 133%;
            }
            .cta-btn:disabled {
                opacity: 0.5;
            }
        }
    }
</style>
